// Generated by CoffeeScript 2.7.0
var AssignmentResponseMixin;

export default AssignmentResponseMixin = {
  props: {
    assignmentResponse: Skylark.App.Model.Response,
    disappearedFieldIds: {
      type: Array,
      default: function() {
        var base;
        return (typeof (base = this.responseable).getDisappearedFieldIdsOnInit === "function" ? base.getDisappearedFieldIdsOnInit() : void 0) || [];
      }
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      response: this.assignmentResponse
    };
  },
  methods: {
    getResponse: function(validate_required = true) {
      var response;
      if (validate_required) {
        response = this.beforeSave();
        this.saving = false;
        return response;
      } else {
        return {
          entries_attributes: this.$refs.fieldsView.getEntries(true)
        };
      }
    },
    updateResponse: function(response = new Skylark.App.Model.Response()) {
      return this.response = response;
    },
    removeCache: function() {
      return this._removeCache();
    },
    _getResponse: function() {
      return {
        entries_attributes: this.$refs.fieldsView.getEntries()
      };
    }
  }
};
